import api from './../api';
import request from "../utils/requestToJavaServer";
export function File_Upload(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.fileApi.FILE_UPLOAD, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function File_Merge(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.fileApi.FILE_MERGE, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function File_Data({ rawDataId, startTime }: any) {
    return new Promise((resolve, reject) => {
        request.get(api.fileApi.FILE_DATA, {
            params: {
                rawDataId, startTime
            }
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function File_Sample({ fileName, index }: any) {
    return new Promise((resolve, reject) => {
        request.get(api.fileApi.FILE_SAMPLE, {
            params: {
                fileName, index
            }
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function File_Info({rawDataId}:any){
    return new Promise((resolve,reject)=>{
        request.get(api.fileApi.FILE_INFO,{
            params:{rawDataId}
        }).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        })
    })
}
